<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { revenueChart } from "./data-profile";
import PerfilPersona from "../../../components/Perfiles/perfil-persona";
import PerfilEmpresa from "../../../components/Perfiles/perfil-empresa";

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Mi Perfil",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, PerfilPersona, PerfilEmpresa },
  data() {
    return {
      revenueChart: revenueChart,
      title: "Mi perfil",
      items: [],
      tabDatos: "activeTab",
      tabEmpresa: "noActiveTab",
      statData: [
        {
          icon: "bx bx-check-circle",
          title: "Completed Projects",
          value: "125",
        },
        {
          icon: "bx bx-hourglass",
          title: "Pending Projects",
          value: "12",
        },
        {
          icon: "bx bx-package",
          title: "Total Revenue",
          value: "$36,524",
        },
      ]
    };
  },
  methods:{
    changeTab(who){
      if(this.tabDatos == "activeTab" && who != 'datos'){
        this.tabDatos = "noActiveTab";
        this.tabEmpresa = "activeTab";
        this.title = "Información de la Empresa";        
      }else if(this.tabEmpresa == "activeTab" && who != 'empresa'){
        this.tabDatos = "activeTab";
        this.tabEmpresa = "noActiveTab";
        this.title = "Mi perfil";
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <b-tabs>
          <b-tab active @click="changeTab('datos')">
            <template #title>
              <i :class="`bx  bx-user-circle mr-1`"></i>
              <span :class="tabDatos">Datos</span>
            </template>
            <PerfilPersona/>
          </b-tab>
          <b-tab @click="changeTab('empresa')">
            <template #title>
              <i :class="`bx  bx-user-circle mr-1`"></i>
              <span :class="tabEmpresa">Empresa</span>
            </template>
            <PerfilEmpresa/>
          </b-tab>
        </b-tabs>        
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
.space-beetwen {
  justify-content: space-between;
}
.activeTab{
  color: black;
}
.noActiveTab{
  color: white;
}
</style>